module.exports = __webpack_public_path__ + "static/landing_choose_platform-69fdbfa1b3ea670ea40fedc0d4566356.svg";